/**
 * The CMS query selects `Content { item }`. `items` is a legacy alias that
 * `normalizeItemResponse` grafts on in ssr.js, and that CMS preview never has
 * because it calls Optimizely Graph directly. Read through here so both shapes work.
 */
export const getOptimizelyItem = (content) =>
    content?.item ?? content?.items?.[0] ?? content?.Content?.item ?? content?.Content?.items?.[0]

export const hasOptimizelyContent = (content) => Boolean(getOptimizelyItem(content))

// The CMS Privacy Policy page is authored per-brand as 'gar-privacy-policy' / 'dyn-privacy-policy'.
export const getPrivacyPolicyPageKey = (isGarage) =>
    isGarage ? 'gar-privacy-policy' : 'dyn-privacy-policy'
